import { render } from "./Spbe.vue?vue&type=template&id=4cd45fa0"
import script from "./Spbe.vue?vue&type=script&lang=js"
export * from "./Spbe.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__